var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.spinnings)?_c('div',{staticStyle:{"z-index":"8999","position":"fixed","top":"0","width":"100%","height":"100%","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","background-color":"rgba(1,1,1,0.2)"}},[_c('a-spin',{attrs:{"size":"large","tip":"正在加载中..."}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }